import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import MasterplanOverview from 'modules/pages/dacum/overview';
import React from 'react';

const OverviewPage = () => {
  const { appName } = useAppName();

  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title={PAGES[appName]?.overview?.title || ''}
          description={PAGES[appName]?.overview?.description || ''}
        />
        <MasterplanOverview />
      </Stack>
    </Container>
  );
};

export default OverviewPage;
